<template>
    <!-- Pro toggle hidden - defaulting to pro mode for all users -->
    <div class="pro-toggle-container" style="display: none;">
        <button
            class="pro-toggle-btn"
            :class="{ active: isProMode }"
            @click="toggleProMode"
            :title="isProMode ? 'Switch to Standard view' : 'Switch to Pro view'"
        >
            <span class="toggle-label">Pro</span>
            <span class="toggle-icon">&#x26A1;</span>
        </button>
    </div>
</template>

<script>
export default {
    name: 'ProModeToggle',

    data() {
        return {
            isProMode: true  // Default to pro mode
        };
    },

    methods: {
        toggleProMode() {
            this.isProMode = !this.isProMode;
            this.applyMode();
        },

        applyMode() {
            if (this.isProMode) {
                document.body.classList.add('pro-mode');
                document.body.classList.remove('standard-mode');
            } else {
                document.body.classList.remove('pro-mode');
                document.body.classList.add('standard-mode');
            }
        }
    },

    mounted() {
        // Always enable pro mode - toggle is hidden
        this.isProMode = true;
        this.applyMode();
    }
};
</script>

<style scoped>
.pro-toggle-container {
    display: inline-flex;
}

.pro-toggle-btn {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0.4rem 0.75rem;
    background: transparent;
    border: 1px solid rgba(139, 92, 246, 0.25);
    border-radius: 20px;
    color: var(--compass-text-secondary, #7d8590);
    font-size: 0.75rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.25s ease;
}

.pro-toggle-btn:hover {
    border-color: rgba(139, 92, 246, 0.5);
    color: var(--compass-text-primary, #e6edf3);
}

.pro-toggle-btn.active {
    background: linear-gradient(135deg, var(--compass-purple, #8b5cf6), var(--compass-pink, #ec4899));
    border-color: transparent;
    color: white;
    box-shadow: 0 2px 12px rgba(139, 92, 246, 0.35);
}

.toggle-label {
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.toggle-icon {
    font-size: 0.9rem;
}

/* Light mode */
body:not(.dark-mode) .pro-toggle-btn,
body:not(.dark-mode) .pro-toggle-btn {
    color: #6b7280;
}

body:not(.dark-mode) .pro-toggle-btn:hover,
body:not(.dark-mode) .pro-toggle-btn:hover {
    color: #374151;
}
</style>
